import styles from './style.postcss';

import React from 'react';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';
import is from 'is_js';
import { List } from 'immutable';
import classnames from 'classnames';
import {
  connect,
  Grid,
  PageCard,
  StudentCard,
  Icon,
  moment,
  ApiCall,
  ConfirmDialog,
  testClass,
} from 'omni-common-ui';
import {
  actions as individualDevelopmentPlans,
  accessors as idpAccessors,
} from 'data/IndividualDevelopmentPlans';
import { actions as GroupMembers } from 'data/GroupMembers';
import { actions as groupActions } from 'containers/Group';
import { BottomButtons } from 'containers/Group/IndividualDevelopmentPlan';
import StudentCardProfile from 'containers/StudentCardProfile';
import UnsavedChangesTrackingPageComponent from 'components/UnsavedChangesTrackingPageComponent';
import AddInternalNoteControl from 'components/AddInternalNoteControl';
import UnsavedChangesWarning from 'components/UnsavedChangesWarning';
import NoContentMessage from 'components/NoContentMessage';
import RejcetNotePopup from 'components/RejectNotePopup';
import UserInfo from './UserInfo';
import { Modes } from './routes';

class IndividualDevelopmentPlanApprovalView extends UnsavedChangesTrackingPageComponent {
  constructor(props) {
    super(props);
    this.state = { wasContentEditMade: false, isAnyMandatoryEmpty: false };

    this._onDiscardClick = this._onDiscardClick.bind(this);
    this._onOverallChanged = this._onOverallChanged.bind(this);
    this._onOverallRecommendationChanged = this._onOverallRecommendationChanged.bind(this);
    this._onSkillSuggestionChanged = this._onSkillSuggestionChanged.bind(this);
    this._onDialogCancelled = this._onDialogCancelled.bind(this);
    this._onRejectStudentIdpReport = this._onRejectStudentIdpReport.bind(this);
  }

  componentWillMount() {
    super.componentWillMount();
    this._fetchIdpApprovalContents(this.props, true);
    this._initCommentsInEditMode();
  }

  componentWillReceiveProps(nextProps) {
    this._fetchIdpApprovalContents(nextProps);
    this._initCommentsInEditMode(nextProps);
  }

  _isChangesPresent() {
    return IndividualDevelopmentPlanApprovalView.isInEditMode(this.props) &&
        this.state.wasContentEditMade;
  }

  _wasContentEditMade() {
    return IndividualDevelopmentPlanApprovalView.isInEditMode(this.props) &&
        this.state.wasContentEditMade;
  }

  _setWasContEditMade(wasContentEditMade) {
    if (this.state.wasContentEditMade === wasContentEditMade) return;
    this.setState({ wasContentEditMade });
  }

  _initCommentsInEditMode(props = this.props) {
    const isInEditMode = IndividualDevelopmentPlanApprovalView.isInEditMode;
    if (! props.idpApprovalContents ||
        props.idpApprovalContents.size === 0 ||
        ! IndividualDevelopmentPlanApprovalView.isInEditMode(props) ||
        (! isInEditMode(this.props) && isInEditMode(props))) return;
    const idpApprovalContent = props.idpApprovalContents.find((content) =>
        content.idpId === props.idpId);
    if (! idpApprovalContent) return;
    const {
      overallSuggestion,
      overallRecommendation,
      participationId,
      skillSuggestions,
      idpId,
    } = idpApprovalContent;
    if (this.state.wasContentEditMade) return;
    this._onEditComments(
      overallSuggestion,
      participationId,
      skillSuggestions,
      idpId,
      overallRecommendation,
    );
  }

  _isContentInEditMode(props, idpId) {
    const isPageInEditMode = IndividualDevelopmentPlanApprovalView.isInEditMode(props);
    return isPageInEditMode && idpId === props.idpId;
  }

  _onEditComments(
    overallSuggestion,
    participationId,
    skillSuggestions,
    idpId,
    overallRecommendation = '',
  ) {
    this.setState({
      overallSuggestion: overallSuggestion || '',
      overallRecommendation: overallRecommendation || '',
      participationId,
      skillSuggestions: this._getInitialSkillSuggestions(skillSuggestions),
    });
    if (Modes.EDIT !== this.props.mode || idpId !== this.props.idpId) {
      this._changeMode(Modes.EDIT, idpId);
    }
  }

  _getInitialSkillSuggestions(skillSuggestions) {
    return skillSuggestions.toJS().map((skillSuggestion) => ({
      skillId: skillSuggestion.skillId,
      suggestion: skillSuggestion.suggestion || '',
      isManuallyAdded: !! skillSuggestion.isManuallyAdded,
      selectedRecommendationList: skillSuggestion.selectedRecommendationList,
    }));
  }

  _onApproveClick(idpId = this.props.idpId, { groupIdpId } = this.props) {
    this.props.approveStudentIdpReport(idpId, groupIdpId)
      .then(() => this._changeMode());
  }

  _onRejectStudentIdpReport(rejectedComment = '', idpId = this.props.idpId, { groupIdpId } = this.props) {
    this.props.rejectStudentIdpReport(idpId, groupIdpId, rejectedComment)
      .then(() => this._changeMode());
  }

  _onRejectClick(idpId) {
    this._changeMode(Modes.REJECT, idpId);
  }

  _changeMode(mode = '', idpId) {
    const { buildRoute } = this.props;
    this._forcePushRoute(buildRoute({ mode, idpId }));
  }

  _fetchIdpApprovalContents(props = this.props, shouldForceFetch = false) {
    const { groupIdpId } = props;
    shouldForceFetch ?
        this.props.fetchIdpApprovalList(groupIdpId) :
        this.props.fetchIdpApprovalListIfNeeded(groupIdpId);
  }

  _renderApprovalList() {
    if (! this.props.idpApprovalContents) return;
    return this.props.idpApprovalContents.map((idpApprovalContent) => {
      if (! idpApprovalContent) return null;
      return <Grid.Group key={idpApprovalContent.idpId}>
        <PageCard className={testClass('idp-approval')}>
          <PageCard.Heading className={styles.IndividualDevelopmentPlanApprovalView_pageHeading}>
            {this._renderStudentCard(idpApprovalContent)}
          </PageCard.Heading>
          <PageCard.Heading>
            {this._renderReportLink(idpApprovalContent)}
          </PageCard.Heading>
          <PageCard.Content className={styles.IndividualDevelopmentPlanApprovalView_pageContent}>
            {this._renderTeacherAndOverall(idpApprovalContent)}
            {this._renderSuggestions(idpApprovalContent)}
            {this._renderBottomButtons(idpApprovalContent)}
          </PageCard.Content>
        </PageCard>
      </Grid.Group>;
    });
  }

  _renderReportLink({ studentInfo: { id: studentId } }) {
    const { groupId, groupIdpId } = this.props;
    const link = `/group/${groupId}/progress-report/${groupIdpId}/student/${studentId}`;
    return <Link className={classnames(styles.IndividualDevelopmentPlanApprovalViewLink, testClass('report-link'))}
        to={this.props.buildRoute(link)}
        draggable={false}>
      Progress Report <Icon id="arrow-right"
          className={styles.IndividualDevelopmentPlanApprovalViewLink_icon} />
    </Link>;
  }

  _renderStudentCard({ studentInfo }) {
    return <StudentCard borderless backgroundless>
      <StudentCardProfile withoutBottomPadding
          studentId={studentInfo.id} />
    </StudentCard>;
  }

  _renderTeacherAndOverall({
    teacherId,
    overallSuggestion,
    overallRecommendation,
    suggestedTime,
    idpId,
    isSimplifiedTeacherFeedback,
  }) {
    const { timeZone } = this.props;
    if (! timeZone || ! teacherId) return;
    const dateStr = is.existy(suggestedTime) && is.existy(timeZone) ?
      moment.parseZone(suggestedTime).clone().tz(timeZone).format('YYYY-MM-DD') : '';
    return <div>
      <UserInfo id={teacherId.toString()}
          dateStr={dateStr}
          className={styles.IndividualDevelopmentPlanApprovalView_userInfo} />
      {this._renderOverall(overallSuggestion, idpId)}
      {isSimplifiedTeacherFeedback ?
          this._renderRecommendation(overallRecommendation, idpId) : null}
    </div>;
  }

  _renderRecommendation(overallRecommendation, idpId) {
    const isContentInEditMode = this._isContentInEditMode(this.props, idpId);
    const titleClasses =
        classnames(styles._overallTitle, { [styles.__noGray]: isContentInEditMode });
    const content = isContentInEditMode ?
        this.state.overallRecommendation :
        overallRecommendation;
    return <div className={styles.IndividualDevelopmentPlanApprovalView_overall}>
      <div className={titleClasses}>Recommendation</div>
      {this._renderContent(content, isContentInEditMode, 'recommendation')}
    </div>;
  }

  _renderOverall(overallSuggestion, idpId) {
    const isContentInEditMode = this._isContentInEditMode(this.props, idpId);
    const overallTitleClasses =
        classnames(styles._overallTitle, { [styles.__noGray]: isContentInEditMode });
    const content = isContentInEditMode ?
        this.state.overallSuggestion :
        overallSuggestion;
    return <div className={styles.IndividualDevelopmentPlanApprovalView_overall}>
      <div className={overallTitleClasses}>Overall</div>
      {this._renderContent(content, isContentInEditMode, 'overall')}
    </div>;
  }

  _renderSuggestions({
    skillSuggestions,
    idpId,
    shouldShowSuggestions,
    isSimplifiedTeacherFeedback,
  }) {
    if (isSimplifiedTeacherFeedback) return;
    if (! shouldShowSuggestions) return;
    return skillSuggestions.map((skillSuggestion, index) => {
      const isContentInEditMode = this._isContentInEditMode(this.props, idpId);
      const skillTitle = `${skillSuggestion.name || ''}` +
          ` ${idpAccessors.formatHfv4SkillScore(skillSuggestion, '')} ` +
          '- Suggestions';
      const skillTitleClasses =
        classnames(styles._suggestionTitle, { [styles.__noGray]: isContentInEditMode });
      const content = isContentInEditMode ?
          this.state.skillSuggestions && this.state.skillSuggestions[index].suggestion :
          skillSuggestion.suggestion;

      return <div key={skillSuggestion.name || index}
          className={styles.IndividualDevelopmentPlanApprovalView_suggestionCard}>
        <div className={skillTitleClasses}>{skillTitle}</div>
        {this._renderContent(
          content,
          isContentInEditMode,
          index,
        )}
      </div>;
    });
  }

  _onOverallRecommendationChanged(text) {
    this._setWasContEditMade(true);
    this.setState({ overallRecommendation: text });
  }

  _onOverallChanged(text) {
    this._setWasContEditMade(true);
    this.setState({ overallSuggestion: text });
  }

  _onSkillSuggestionChanged(text, index) {
    this._setWasContEditMade(true);
    const skillSuggestions = this.state.skillSuggestions.map((skillSuggestion, _index) => {
      if (index !== _index) return skillSuggestion;
      return Object.assign({}, skillSuggestion, { suggestion: text });
    });
    this.setState({ skillSuggestions });
  }

  _renderContent(content, isContentInEditMode, contentType) {
    let onContentChanged;
    if (contentType === 'overall') {
      onContentChanged = this._onOverallChanged;
    } else if (contentType === 'recommendation') {
      onContentChanged = this._onOverallRecommendationChanged;
    } else {
      onContentChanged = this._onSkillSuggestionChanged;
    }

    if (isContentInEditMode) {
      return <AddInternalNoteControl text={content}
          maxCharacters={1320}
          onChange={(text) => onContentChanged(text, contentType)}
          noAutoScroll />;
    }
    return <div className={styles._content}>{content}</div>;
  }

  _onDiscardClick() {
    this._setWasContEditMade(false);
    this._changeMode('');
  }

  _onDialogCancelled() {
    this._changeMode('');
  }

  _onSaveClick(idpId) {
    const idpRow = this.props.idpApprovalContents &&
      this.props.idpApprovalContents.find((c) => c && c.idpId === idpId);
    const isSimplified = idpRow && idpRow.isSimplifiedTeacherFeedback;
    const submittedSuggestions = isSimplified ? {
      overallSuggestion: this.state.overallSuggestion || '',
      overallRecommendation: this.state.overallRecommendation || '',
    } : {
      overallSuggestion: this.state.overallSuggestion || '',
      participationId: this.state.participationId,
      skillSuggestions: this.state.skillSuggestions,
    };
    this.props.submitIdpFeedbackSuggestions(idpId, submittedSuggestions, this.props.groupIdpId)
      .then(() => {
        this._fetchIdpApprovalContents(this.props, true);
        this._onDiscardClick();
      });
  }

  _markIfAnyMandatoryEmpty(isAnyMandatoryEmpty) {
    if (isAnyMandatoryEmpty === this.state.isAnyMandatoryEmpty) return;
    this.setState({ isAnyMandatoryEmpty });
  }

  _renderBottomButtons(idpApprovalContent) {
    const {
      overallSuggestion,
      overallRecommendation,
      participationId,
      skillSuggestions,
      idpId,
      isSimplifiedTeacherFeedback,
    } = idpApprovalContent;
    if (this._isContentInEditMode(this.props, idpId)) {
      const hasMandatoryEmpty = isSimplifiedTeacherFeedback ?
        ! this.state.overallSuggestion.trim() || ! this.state.overallRecommendation.trim() :
        ! this.state.overallSuggestion.trim();
      this._markIfAnyMandatoryEmpty(hasMandatoryEmpty);
      return <BottomButtons primaryText="SAVE"
          secondaryText="DISCARD"
          isPrimaryDisabled={hasMandatoryEmpty}
          onPrimaryClick={() => this._onSaveClick(idpId)}
          onSecondaryClick={this._onDiscardClick}
          className={styles.IndividualDevelopmentPlanApprovalView_bottomButtons} />;
    }
    const isPageInEditMode = IndividualDevelopmentPlanApprovalView.isInEditMode(this.props);
    const saveButton = {
      text: 'APPROVE',
      onClick: () => this._onApproveClick(idpId),
      disabled: !! isPageInEditMode,
      primary: true,
    };
    const rejectButton = {
      text: 'REJECT',
      onClick: () => this._onRejectClick(idpId),
      disabled: !! isPageInEditMode,
    };
    const editButton = {
      text: 'EDIT',
      onClick: () =>
          this._onEditComments(
            overallSuggestion,
            participationId,
            skillSuggestions,
            idpId,
            overallRecommendation,
          ),
      disabled: !! isPageInEditMode,
    };
    return <BottomButtons buttons={[saveButton, rejectButton, editButton]}
        className={styles.IndividualDevelopmentPlanApprovalView_bottomButtons} />;
  }

  _renderDeleteConfirmDialog() {
    const isInRejectMode = IndividualDevelopmentPlanApprovalView.isInRejectMode(this.props);
    return isInRejectMode && <RejcetNotePopup isOpen
        isLoading={this.props.isAnyApiCallSaving || this.props.isAnyApiCallLoading}
        onSave={this._onRejectStudentIdpReport}
        onCancel={this._onDialogCancelled} />;
  }

  _renderUnsavedChangesWarningDialog() {
    if (IndividualDevelopmentPlanApprovalView.isInEditMode(this.props) &&
        this.state.isAnyMandatoryEmpty) {
      return <ConfirmDialog isOpen={!! this._isNavigationWithChangesRequested()}
          primaryButtonContent="Stay"
          secondaryButtonContent="Leave"
          content="Are you sure you want to leave this page and lose unsaved changes?"
          onPrimaryClick={() => {
            this._clearRequestedLocation();
          }}
          onSecondaryClick={() => {
            this._onDiscardClick();
            this._forcePushRequestedLocation();
          }}
          onRequestClose={() => {
            this._clearRequestedLocation();
          }} />;
    }
    return <UnsavedChangesWarning isOpen={
          !! this._isNavigationWithChangesRequested()}
        isSaving={this.props.isAnyApiCallSaving}
        onSaveClicked={() => {
          this._onSaveClick(this.props.idpId);
        }}
        onDiscardClicked={() => {
          this._onDiscardClick();
          this._forcePushRequestedLocation();
        }}
        onCloseClicked={() => {
          this._clearRequestedLocation();
        }}
        onSaved={() => {
          this._forcePushRequestedLocation();
        }} />;
  }

  _renderNoContentMessage() {
    const { idpApprovalContents } = this.props;
    if ((! idpApprovalContents || idpApprovalContents.size === 0) &&
        ! this.props.isAnyApiCallLoading) {
      return <NoContentMessage className={testClass('empty')}
          text="There are no reports waiting for approval at this time." />;
    }
  }

  render() {
    return <Grid outerMargin>
      {this._renderApprovalList()}
      {this._renderNoContentMessage()}
      {this._renderUnsavedChangesWarningDialog()}
      {this._renderDeleteConfirmDialog()}
    </Grid>;
  }
}

IndividualDevelopmentPlanApprovalView.isInEditMode = ({ params }) =>
  params.mode === Modes.EDIT && params.idpId;

IndividualDevelopmentPlanApprovalView.isInRejectMode = ({ params }) =>
  params.mode === Modes.REJECT && params.idpId;

IndividualDevelopmentPlanApprovalView.propTypes = {
  groupIdpId: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  timeZone: PropTypes.string,
  idpApprovalList: PropTypes.shape(),
  idpApprovalContents: PropTypes.shape(),
  idpId: PropTypes.string,
  fetchIdpApprovalList: PropTypes.func.isRequired,
  fetchIdpApprovalListIfNeeded: PropTypes.func.isRequired,
  fetchIdpFeedbackSuggestionsIfNeeded: PropTypes.func.isRequired,
  submitIdpFeedbackSuggestions: PropTypes.func.isRequired,
  approveStudentIdpReport: PropTypes.func.isRequired,
  rejectStudentIdpReport: PropTypes.func.isRequired,
  isAnyApiCallSaving: PropTypes.bool,
  buildRoute: PropTypes.func.isRequired,
  pushRoute: PropTypes.func.isRequired,
};

function mapStatToProps(state, ownProps) {
  const { groupId, groupIdpId, idpId, mode } = ownProps.params;
  const groupIdpList = idpAccessors.getGroupIdpList(state, groupId);
  const idpDetailList = state.get('rootReducer').get('individualDevelopmentPlan');
  const idpList = idpAccessors.getIdpList(groupIdpList, groupIdpId);
  const idpApprovalList = state.get('rootReducer').get('idpApprovalList').get(groupIdpId);
  const members = GroupMembers.getMembersByGroup(state, groupId);
  const { timeZone } = groupActions.getCentre(state, groupId);
  let idpApprovalContents;
  if (idpApprovalList && idpApprovalList.size > 0 && members.size > 0 && idpList) {
    idpApprovalContents = idpApprovalList.map((idpApproval) => idpAccessors
        .getHfv4IdpApprovalContent(
          state,
          groupId,
          groupIdpId,
          idpList,
          idpDetailList,
          members,
          idpApproval.studentIDPId,
        ))
      .filter((idpApprovalContent) => is.not.undefined(idpApprovalContent));
    idpApprovalContents = members.map(({ studentGeneralInfo: { id } }) => idpApprovalContents
        .find((idpApprovalContent) => idpApprovalContent.studentInfo.id === id));
    idpApprovalContents = idpApprovalContents.filter((content) => is.not.undefined(content));
  }
  return {
    groupId,
    groupIdpId,
    idpId,
    mode,
    idpApprovalList,
    idpApprovalContents,
    timeZone,
    isAnyApiCallSaving: !! isAnyApiCallSaving(state),
    isAnyApiCallLoading: !! isAnyApiCallLoading(state),
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign(
    { pushRoute: (path) => dispatch(push(path)) },
    bindActionCreators(individualDevelopmentPlans, dispatch)
  );
}

function isAnyApiCallSaving(state) {
  return !! (state.get('apiCalls') || new List())
    .filter((call, key) =>
      ['PUT', 'POST'].some((method) => key.startsWith(method)))
    .find((call) => ApiCall.State.isLoading(call));
}

function isAnyApiCallLoading(state) {
  return !! (state.get('apiCalls') || new List())
    .filter((call, key) =>
      ['GET'].some((method) => key.startsWith(method)))
    .find((call) => ApiCall.State.isLoading(call));
}

export default connect(mapStatToProps, mapDispatchToProps)(
  withRouter(IndividualDevelopmentPlanApprovalView));



// WEBPACK FOOTER //
// ./containers/Group/ProgressReportHFv4/IndividualDevelopmentPlanApprovalView/component.jsx